var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.445312H2C1.46957 0.445313 0.960859 0.656026 0.585786 1.0311C0.210714 1.40617 0 1.91488 0 2.44531V16.4453C0 16.9757 0.210714 17.4845 0.585786 17.8595C0.960859 18.2346 1.46957 18.4453 2 18.4453H6L9 21.4453L12 18.4453H16C17.1 18.4453 18 17.5453 18 16.4453V2.44531C18 1.34531 17.1 0.445312 16 0.445312ZM16 16.4453H11.17L10.58 17.0353L9 18.6153L7.41 17.0253L6.83 16.4453H2V2.44531H16V16.4453ZM8 13.4453H10V15.4453H8V13.4453ZM9 5.44531C10.1 5.44531 11 6.34531 11 7.44531C11 9.44531 8 9.19531 8 12.4453H10C10 10.1953 13 9.94531 13 7.44531C13 5.23531 11.21 3.44531 9 3.44531C6.79 3.44531 5 5.23531 5 7.44531H7C7 6.34531 7.9 5.44531 9 5.44531Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfo);
export default __webpack_public_path__ + "static/media/ic_info.3833f698c9b07bfeb4ef6fa633a1b02b.svg";
export { ForwardRef as ReactComponent };